var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.848 46.0027H21.1389C16.7988 46.0027 13.3 42.504 13.3 38.1638C13.3 33.8679 16.7988 30.325 21.1389 30.325H58.3403C65.8249 30.325 71.848 36.3923 71.848 43.8326V46.0027Z",
    fill: "#284993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2621 54.1516H80.9712C85.3114 54.1516 88.8101 57.6503 88.8101 61.9904C88.8101 66.3306 85.3114 69.8293 80.9712 69.8293H45.9399C37.2596 69.8293 30.2621 62.8319 30.2621 54.1516Z",
    fill: "#284993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1516 77.9782V79.9711C55.1516 84.3113 58.6503 87.81 62.9905 87.81C67.3306 87.81 70.8293 84.3113 70.8293 79.9711V77.9782H55.1516Z",
    fill: "#284993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9585 22.1761V20.1389C46.9585 15.7987 43.4598 12.3 39.1196 12.3C34.8237 12.3443 31.325 15.843 31.325 20.1389V22.1318H46.9585V22.1761Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.10535ef6cfec7aee6618d4cc1cb54eba.svg";
export { ForwardRef as ReactComponent };